/** @jsx jsx */
/** @jsxFrag */
import { ClassNames, jsx } from '@emotion/react';
import React from 'react';
import { CompanyReference } from 'types/Reference';

export interface ReferenceListCardLogoProps extends React.HTMLAttributes<HTMLDivElement> {
  reference: CompanyReference;
}

const ReferenceListCardLogo: React.FC<ReferenceListCardLogoProps> = ({ reference }) => {
  return (
    <ClassNames>
      {() => (
        <div
          css={{
            alignItems: 'center',
            background: '#FFF',
            border: '1px solid #CCC',
            borderRadius: '5px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            padding: '20px',
          }}
        >
          <div css={{ alignItems: 'center', display: 'flex', height: '60px' }}>
            <img
              css={{ alignSelf: 'center', maxHeight: '60px', maxWidth: '200px', width: 'auto' }}
              src={reference.logo}
              alt=''
            />
          </div>
        </div>
      )}
    </ClassNames>
  );
};
export default ReferenceListCardLogo;
